import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Button from '../common/Button';
import { map } from 'lodash';
import BusinessLandingHeader from './BusinessLandingHeader.jsx';
import BusinessLandingFooter from './BusinessLandingFooter.jsx';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import { FormGroup, Modal, DropdownButton, MenuItem } from 'react-bootstrap';

export default class businessLanding extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(
      () => {
        const tesNode = ReactDOM.findDOMNode(this.refs.benefits);
        if (window.localStorage.getItem('Benefits') && JSON.parse(window.localStorage.getItem('Benefits'))) {
          console.log(tesNode, tesNode.offsetTop);
          window.scrollTo(0, tesNode.offsetTop, 500);
          window.localStorage.removeItem('Benefits');
        }
      },
      0
    );
  }

  componentWillUnmount() { }

  render() {
    return (
      <div className="business-body">
        <BusinessLandingHeader router={this.props.router} activeLink={true} metaTagKey={'business-landing'} />

        <div className="main-wrapper-business">
          <div className="banner-container">
            <div className="flex-container">
              <div className="loader" />
              <div className="flexslider">
                <ul className="slides">
                  <li>
                    <img src={`${imageBasePath}/business-carcility.png`}  alt="Business carcility"/>
                    <div className="flex-caption">
                      <div className="bannerCaptionBox">
                        <h2 className="not-transform">
                          More business
                          your way.
                                                </h2>
                        <p>
                          Get an all-in-one solution that simplifies your car service business.

                        </p>
                        <div
                          data-labelledby="Get Started"
                          onClick={() => this.props.router.push(`${appBasePath}/sign-up`)}
                          className="btn-business"
                          data-labelledby="Get Started"
                        >
                          Get Started
                                                </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="bannerBottomWrap">
                <div className="bannerBottomText">
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="bannerBottomItem">
                          <div className="thumb">
                            <img
                              src={`${imageBasePath}/icons/more-jobs.png`}
                              className="img-responsive"
                            />
                          </div>
                          <div className="textContent">
                            <h5 className="">
                              More jobs,<br />
                              more visibility
                                                        </h5>
                            <p>
                              Easy and affordable access to new customers that helps you expand your clients.
                                                        </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="bannerBottomItem">
                          <div className="thumb">
                            <img
                              src={`${imageBasePath}/icons/build-trust.png`}
                              className="img-responsive"
                            />

                          </div>
                          <div className="textContent">
                            <h5>
                              Build Trust with reviews<br />
                              and ratings
                                                        </h5>
                            <p>
                              Add to your reputation with help of trusted online review and ratings.
                                                        </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="bannerBottomItem">
                          <div className="thumb">
                            <img
                              src={`${imageBasePath}/icons/fingertips.png`}
                              className="img-responsive"
                            />

                          </div>
                          <div className="textContent">
                            <h5>
                              Manage your shop at<br />
                              your fingertips
                                                        </h5>
                            <p>
                              Get end-to- end tect support that helps you run your operations online.
                                                        </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="joinTheRevolution" id="joinTheRevolution">
            <div className="container" ref="benefits">
              <h2>Join The Revolution</h2>
              <div className="joinTheRevolutionItem">
                <div className="row">
                  <div className="col-sm-5 adj-box">
                    <div className="textContent">
                      <div className="thumb">
                        <img
                          src={`${imageBasePath}/icons/jobs.png`}
                          className="img-responsive"
                        />
                      </div>
                      <h4>Automation</h4>
                      <p>
                        Our global platform programmatically matches customers with qualified service providers in the vicinity - making it easy for new customers to discover you.
                                            </p>
                      <br className="hiden-xs" /><br className="hiden-xs" /><br /><br />
                      <div className="thumb">
                        <img
                          src={`${imageBasePath}/icons/no-paper.png`}
                          className="img-responsive"
                        />
                      </div>
                      <h4>No paperwork, no hassle</h4>
                      <p>
                        With every aspect of the service online, you don't have to spend time to generate bills, or search for receipts.
                                            </p>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <img src={`${imageBasePath}/business-automation-carcility.jpg`} alt="Business automation carcility" className="img-responsive" />
                  </div>
                </div>
              </div>
              <div className="joinTheRevolutionItem">
                <div className="row">
                  <div className="col-sm-5 pull-right adj-box">
                    <div className="textContent">
                      <div className="thumb">
                        <img
                          src={`${imageBasePath}/icons/great-rates.png`}
                          className="img-responsive"
                        />
                      </div>
                      <h4>No more unwanted spends</h4>
                      <p>
                        With Carcility's tech-oriented approach, you don't have to spend time and money to getting more clients. We'll do it for you.
                                                {' '}
                      </p>
                      <br className="hiden-xs" /><br className="hiden-xs" /><br /><br />
                      <div className="thumb">
                        <img
                          src={`${imageBasePath}/icons/reputation.png`}
                          className="img-responsive"
                        />

                      </div>
                      <h4>Promote your brand</h4>
                      <p>
                        Get trusted reviews and ratings from your customer - increase your reputation and business by (online)
                                                <br />
                        world of mouth.
                                            </p>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <img src={`${imageBasePath}/business-review-ratings-carcility.jpg`} alt="Business review ratings carcility" className="img-responsive" />
                  </div>
                </div>
              </div>
              <div className="joinTheRevolutionItem">
                <div className="row">
                  <div className="col-sm-5 adj-box">
                    <div className="textContent">
                      <div className="thumb">
                        <img
                          src={`${imageBasePath}/icons/secure.png`}
                          className="img-responsive"
                        />
                      </div>
                      <h4>Fast and secure payment</h4>
                      <p>Guaranteed payment,Do the job, get paid. It’s that easy.</p>
                      <br className="hiden-xs" /><br className="hiden-xs" /><br /><br />
                      <div className="thumb">
                        <img
                          src={`${imageBasePath}/icons/analytics.png`}
                          className="img-responsive"
                        />
                      </div>
                      <h4>Analytics & Reporting</h4>
                      <p>
                        Gain real time and aggregated insights into sales performance. Easily identify your best performing services, and where you can improve.
                                            </p>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <img src={`${imageBasePath}/business-secure-payment-carcility.png`} alt="Business secure payment carcility" className="img-responsive" />

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="how-works" className="howItWorks">
            <div className="container">
              <div className="col-sm-10 col-sm-offset-1">
                <h2>How it works</h2>
                <h5>A simple step to get you started to win more customers, better servicing and experience in your car repair business :</h5>
                <div className="howItWorksItem">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="serialNumber">
                        <span className="adj-no-1">01</span>
                      </div>
                      <div className="howItWorksBox">
                        <h6>List your business</h6>
                        <p>Register your business, and list the car maintenance services you offer.</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div
                        className="thumb sub-bg-img"
                        style={{
                          backgroundImage: `url(${imageBasePath}/profile1.jpeg)`
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="howItWorksItem red">
                  <div className="row">
                    <div className="col-sm-6 pull-right">
                      <div className="serialNumber">
                        <span className="adj-no-2-4">02</span>
                      </div>
                      <div className="howItWorksBox red">
                        <h6>Receive service requests</h6>
                        <p>
                          We send you requests from customers looking for auto repairs to service their vehicle.
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div
                        className="thumb sub-bg-img"
                        style={{
                          backgroundImage: `url(${imageBasePath}/profile2.jpeg)`
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="howItWorksItem orange">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="serialNumber">
                        <span className="adj-no-3">03</span>
                      </div>
                      <div className="howItWorksBox">
                        <h6>Send quotes and win jobs</h6>
                        <p>
                          Go through the job requirement - accept or
                                                    <br />
                          reject it based on your performance.
                                                </p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div
                        className="thumb sub-bg-img"
                        style={{
                          backgroundImage: `url(${imageBasePath}/profile3.jpeg)`
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="howItWorksItem blue">
                  <div className="row">
                    <div className="col-sm-6 pull-right">
                      <div className="serialNumber">
                        <span className="adj-no-2-4">04</span>
                      </div>
                      <div className="howItWorksBox red">
                        <h6>Get paid fast</h6>
                        <p>Set up direct deposit, and get paid quicker.</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div
                        className="thumb sub-bg-img"
                        style={{
                          backgroundImage: `url(${imageBasePath}/profile4.jpeg)`
                        }}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="macImage">
            <div className="thumb">
              <img src={`${imageBasePath}/business-overview-carcility.jpg`} alt="Business overview carcility" className="img-responsive" />
            </div>
          </div>
          <div className="signText">
            <div className="container">
              <h6>Sign up now and get started on your first job right away</h6>
              <div
                href=""
                onClick={() => this.props.router.push(`${appBasePath}/sign-up`)}
                className="btn-business"
                data-labelledby="Sign Up"
              >
                Sign Up
                            </div>
            </div>
          </div>
          <div className="bannerBottomWrap what-will-believe">
            <div className="bannerBottomText">
              <div className="container">
                <div className="row">
                  <div className="">
                    <h2>what we believe</h2>
                    <div className="col-sm-4 col-sm-offset-2 col-xs-12">
                      <h4>Success for you is success for Us </h4>
                      <p>
                        Our mission is to provide an exclusive, the most convenient and trusted platform for auto services.
                                            </p>
                      <p>
                        We will help you to transform your business to stay ahead of competition and deliver premium customer experiences.
                                            </p>
                    </div>
                    <div className="col-sm-4 col-sm-offset-1 col-xs-12">
                      <h4>Auto Workshops are the backbone of our business</h4>
                      <p>
                        There are endless doubts in the minds of customers when it comes to their car servicing needs.

                      </p>
                      <p>
                        Customers want peace of mind knowing that they made the right choice. Our products and features will help them make an informed decision - one that's best suited for their specific car needs, convenient and easy on their wallets.



                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="letsStartToday">
            <div className="container">
              <h1>Give your business a free headstart</h1>
              <h1>
                List your business on Carcility for free and let thousands of new users discover you !
                                <br />
                What's more, you will also get access to Carcility's premium service for 30 days - No strings attached.
                                <br />
                We are here to help you at every stage of your journey.
                            </h1>
              <div
                onClick={() => this.props.router.push(`${appBasePath}/sign-up`)}
                className="btn-business"
                data-labelledby="Get Started"
              >
                Get Started
                            </div>
            </div>
          </div>
        </div>
        <BusinessLandingFooter router={this.props.router} />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BusinessLanding/businessLanding.jsx